import { ERROR_CODE_ZUORA_LOCK, CONTACT_SUPPORT_LINK, SIGN_IN_PATH } from '~/javascripts/constants';
import { convertObjectPropsToLowerCase } from '~/javascripts/lib/convert_utils';

// Note: `links` map keys MUST match up to `message` placeholder values to properly create a href
// Ex: message: 'If the problem persists, %{supportLinkStart}contact support%{supportLinkEnd}.,
//     links: {
//       supportLink: CONTACT_SUPPORT_LINK,
//     },
const UNAUTHORIZED_ERROR_TYPE = 'base:unauthorized';
const UNAUTHORIZED_ERROR_TITLE = 'This page is only accessible by authorized users';
const UNAUTHORIZED_ERROR_MAP = {
  title: UNAUTHORIZED_ERROR_TITLE,
  message:
    'Please %{signInLinkStart}sign in%{signInLinkEnd} with an authorized user to view this page. If the problem persists, %{supportLinkStart}contact support%{supportLinkEnd}.',
  links: { supportLink: CONTACT_SUPPORT_LINK, signInLink: SIGN_IN_PATH },
};
const UNAUTHENTICATED_ERROR_TYPE = 'base:unauthenticated';
const UNAUTHENTICATED_ERROR_TITLE = 'You must be signed in to view this page';
const UNAUTHENTICATED_ERROR_MAP = {
  title: UNAUTHENTICATED_ERROR_TITLE,
  message: 'Please %{signInLinkStart}sign in%{signInLinkEnd} to view this page',
  links: { signInLink: SIGN_IN_PATH },
};

export const BASE_ERROR_DICTIONARY = convertObjectPropsToLowerCase({
  [ERROR_CODE_ZUORA_LOCK]: {
    message: 'Operation failed due to a lock competition, please retry later.',
    links: {},
  },
  [UNAUTHORIZED_ERROR_TYPE]: UNAUTHORIZED_ERROR_MAP,
  [UNAUTHENTICATED_ERROR_TYPE]: UNAUTHENTICATED_ERROR_MAP,
});
